import { filterRequest, filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { AdvisorPageActions, GetMeetingAction } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { map, mergeMap } from 'rxjs/operators'
import { MEETING_URL } from 'interfaces/ajax'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { EMPTY, of } from 'rxjs'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { AdvisorFloatPane, ADVISOR_FLOAT_PANE_TYPE } from 'components/features/coaching/advisorMeeting/types/floatPane'
import { FloatingPaneAction, killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'


export const getMeetingEpic: EpicRefined<AdvisorPageActions | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequest(GetMeetingAction.type),
  mergeMap((action) => {
    return get({ url: MEETING_URL, params: { uid: action.payload.params.uid }}).pipe(
      map(({ response }) => {
        const { advisor, ...restMeeting } = response
        const meeting = {
          ...restMeeting,
          advisorUid: advisor.uid,
        }
        return action.success({ advisor, meeting })
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
    )
  }),
)

export const meetingPaneGetMeetingFail: EpicRefined<AdvisorPageActions | FloatingPaneAction> = (action$, store) => action$.pipe(
  filterRequestOfType(GetMeetingAction.type, 'fail'),
  mergeMap(() => {
    const state = store.getState()
    const pane = getItemFromCollection(state.app.floatingPanes.panes, ADVISOR_FLOAT_PANE_TYPE) as AdvisorFloatPane | null

    if (!pane || pane.mode !== 'meeting') {
      return EMPTY
    }

    return of(killAllFloatingPanesActionCreator())
  })
)
